module.exports = __webpack_public_path__ + "static/media/SELECT_NEXT_CONTAINER.33f65e79.svg";